import { useTranslation } from '@mc/i18n'
import { Locations, ProductLine, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { homePath } from 'libs/paths'
import { trackNavigationClick } from '../events'

export const MasterClassLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = ProductLine.MASTERCLASS,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof ProductLine)[keyof typeof ProductLine]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.masterClass')

  const handleMasterClassClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={homePath()}
      className={className}
      onClick={handleMasterClassClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
